import { PremiumServiceEventTypes } from "@/enums/PremiumServiceEventTypes";
import { ServiceTypeEnum } from "@/enums/ServiceTypeEnum";
import Loader from "@/components/loader/Loader.vue";
import draggable from "vuedraggable";
import {PremiumServiceParticipantsLimit} from "@/enums/PremiumServiceParticipantsLimit";

export const ConciergeServicesListMixin = {
  components: {
    Loader,
    draggable
  },
  data() {
    return {
      loading: true,
      category: null,
      search: '',
    }
  },
  async created() {
    Promise.all([
      this.$store.dispatch("getAdditionalServices"),
      await this.$store.dispatch("getLifestyleProgramCategories"),
      this.$store.dispatch("getAwaitingApprovalRequests"),
    ]).then(() => {
      this.loading = false;
    });
  },
  computed: {
    premiumServiceEventTypes() {
      return PremiumServiceEventTypes;
    },
    serviceTypeEnum() {
      return ServiceTypeEnum;
    },
    facilityCurrency() {
      return this.$store.getters.facilityCurrency;
    },
    dragOptions() {
      return {
        animation: 0,
        disabled: !!this.search.length || (!!this.category && this.category !== 'All'),
        ghostClass: "ghost"
      };
    },
    serviceCategories() {
      return this.$store.state.socialClubModule.lifestyleProgramCategories
    },
    serviceRequestsAwaiting() {
      return this.$store.state.additionalServicesModule.serviceRequestsDashboard;
    },
    conciergeServiceParticipantsLimit() {
      return PremiumServiceParticipantsLimit;
    }
  },
  methods: {
    routerBack() {
      this.$router.push("concierge-list")
    },
    openRequest(item) {
      this.$router.push("/concierge-service/" + item.id.toString());
    },
    openDimensions() {
      this.$router.push("/settings?tab=lifestyleProgramsSettings")
    },
    selectCategory(category) {
      this.category = category;
    },
    translateStatus(value) {
      const status = value.replace(/(?:^|\s)\S/g, res => {
        return res.toUpperCase();
      }).replace(/\s+/g, '')

      return this.$i18n.t(`ServiceStatus.${status}`).toString()
    },
    refreshServices() {
      this.loading = true;

      Promise.all([
        this.$store.dispatch("getAdditionalServices")
      ]).then(() => {
        this.loading = false;
      });
    },
    getDimension(item) {
      return item?.categoryId ? this.serviceCategories.find(x => x.id === item.categoryId)?.name : "";
    }
  }
}
